import { camelizeKeys } from "humps";
import {
  BasicCoverProps,
  CategoryData,
  HighLightBannerData,
  HomeWidget,
  Product,
  WidgetComponentsIdEnum,
} from "../types";
import { productsMappers } from "./products.utils";
import { resizeImage } from "./image";

export const widgetData = (
  widget: HomeWidget,
  products: Product[],
  coverData: BasicCoverProps,
  bestCategories: any,
) => {
  switch (widget.id) {
    case WidgetComponentsIdEnum.products_grid:
      return products;
    case WidgetComponentsIdEnum.categories:
      const data = widget.data as CategoryData[];
      return data?.map((data: any) => data?.category);
    case WidgetComponentsIdEnum.cover:
      return coverData;
    default:
      return widget.data;
  }
};

export const widgetsDataMapper = (widgetData: HomeWidget): HomeWidget => {
  const widget = { ...widgetData };

  if (widget.id === WidgetComponentsIdEnum.product_carousel) {
    widget.data = productsMappers(widget.data as Product[]);
  } else if (widget.id === WidgetComponentsIdEnum.banner) {
    // Un banner `specific` llega sin data si el producto al que apunta ya no
    // existe; sin el `?.` el SSR entero de la tienda revienta con
    // "Cannot read properties of undefined (reading 'images')".
    const banner = widget.data as HighLightBannerData | undefined;
    widget.data = {
      ...banner,
      images: banner?.images
        ? banner.images.map((image) => resizeImage(image, 760, 760, 50))
        : undefined,
    } as HighLightBannerData;
  }

  return { ...widget };
};
